
export const REQUEST_ADDVIDEOTAG= 'REQUEST_ADDVIDEOTAG';
export const ADDVIDEOTAG_RECEIVED = 'ADDVIDEOTAG_RECEIVED';